<template>
    <base-dialog :value="dialog" :width="420" :title="title" @input="val => { if (!val) hide() }" @close="hide">
        <div class="inj-det-list">
            <div v-for="item in items" :key="item.id" class="inj-det-row">
                <span class="inj-det-dot" :style="{ background: color }" />
                <div class="inj-det-info">
                    <div class="inj-det-name">{{ item.name }}</div>
                    <div class="inj-det-meta">{{ item.typeLabel }} · {{ item.zoneLabel }}</div>
                </div>
                <div class="inj-det-date">{{ item.dateString }}</div>
            </div>
        </div>
    </base-dialog>
</template>

<script>
import BaseDialog from '@/components/common/BaseDialog'

export default {
    name: 'InjuryDetailsDialog',
    components: { BaseDialog },
    data() {
        return {
            dialog: false,
            label: '',
            color: null,
            items: [],
        }
    },
    computed: {
        title(vm = this) {
            if (!vm.label) return ''
            const count = vm.$tc('statistics.injuries_count', vm.items.length, { count: vm.items.length })
            return `${vm.label} (${count})`
        },
    },
    methods: {
        show({ label, color, items = [] }) {
            const vm = this
            vm.label = label
            vm.color = color
            vm.items = items
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.items = []
        },
    },
}
</script>

<style scoped>
.inj-det-list {
    margin: -20px;
}

.inj-det-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 20px;
    border-bottom: 1px solid var(--v-outline-base);
}

.inj-det-row:last-child {
    border-bottom: none;
}

.inj-det-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.inj-det-info {
    flex: 1;
    min-width: 0;
}

.inj-det-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.inj-det-meta {
    font-size: 11px;
    color: var(--v-txtMuted-base);
    margin-top: 2px;
}

.inj-det-date {
    font-size: 11px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    flex-shrink: 0;
}
</style>
